module.exports = __webpack_public_path__ + "img/extended.15b42604.png";